import { render, staticRenderFns } from "./PresentationPanel.vue?vue&type=template&id=61023ed8&scoped=true"
import script from "./PresentationPanel.vue?vue&type=script&lang=ts"
export * from "./PresentationPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PresentationPanel.vue?vue&type=style&index=0&id=61023ed8&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "61023ed8",
  null
  ,true
)

export default component.exports